// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"ReferenceNumberHeaderPartnerIcon_icon-wrapper__byYTr"};